import { CSSProperties } from 'react';
import { TOP_MENU_BAR_HEIGHT } from '../components/TopMenuBar.tsx/constants';
import { colors } from './colors';
import { BOTTOM_MENU_HEIGHT } from '../routes/BottomRouterNavigation/constants';

const spacing = {
  xxs: '2px',
  xs: '4px',
  xsMedium: '6px',
  small: '8px',
  smallPlus: '10px',
  smallMedium: '12px',
  medium: '16px',
  mediumPlus: '20px',
  mediumLarge: '24px',
  large: '32px',
  xl: '40px',
  xxl: '48px',
  xxxl: '56px',
};

export const spacingInUnits = {
  xxs: 2,
  xs: 4,
  xsMedium: 6,
  small: 8,
  smallPlus: 10,
  smallMedium: 12,
  medium: 16,
  mediumPlus: 20,
  mediumLarge: 24,
  large: 32,
  xl: 40,
  xxl: 48,
  xxxl: 56,
};

interface containerSpacingProps {
  regular: CSSProperties;
  fixedTopBar: CSSProperties;
}

const windowWidth = window.innerWidth;

export const MOBILE_SCREN_WIDTH_THRESHOLD = 767;
export const GENERIC_DESKTOP_CONTENT_ITEM_WIDTH = 500;
export const REGULAR_CONTAINER_MAX_WIDTH = 1080;
export const LEFT_SIDE_NAVIGATOR_WIDTH = 240;
export const LEFT_SIDE_NAVIGATOR_COLLAPSED_WIDTH = 100;
export const LEFT_SIDE_NAVIGATOR_WIDTH_THRESHOLD =
  REGULAR_CONTAINER_MAX_WIDTH + LEFT_SIDE_NAVIGATOR_WIDTH;

export const REGULAR_CONTAINER_PADDING = spacing.smallMedium;
export const isMobileScreen = windowWidth < REGULAR_CONTAINER_MAX_WIDTH;
export const isNarrowMobileScreen = windowWidth < 361;

export const getIsLeftRouterNavigatorShown = () => {
  return window.innerWidth > LEFT_SIDE_NAVIGATOR_WIDTH_THRESHOLD;
};

export const pageContentContainerSpacing: containerSpacingProps = {
  regular: {
    maxWidth: REGULAR_CONTAINER_MAX_WIDTH,
    margin: '0 auto',
    padding: spacing.medium,
    paddingTop: TOP_MENU_BAR_HEIGHT + 12,
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    height: '100%',
    backgroundColor: colors.backgroundMediumLight,
    paddingBottom: getIsLeftRouterNavigatorShown()
      ? spacing.medium
      : BOTTOM_MENU_HEIGHT,
  },
  fixedTopBar: {
    position: 'fixed',
    top: 0,
    width: '100%',
  },
};

export default spacing;
